module.exports = __webpack_public_path__ + "static/img/plat.84cc60e.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/plat.png
// module id = XhtX
// module chunks = 1